module.exports = __webpack_public_path__ + "static/media/firefighter.4ff46c73.jpeg";